import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: null,
        employee: null,
        lastOrder: null,
    },

    mutations: {
        SET_EMPLOYEE(state, employee) {
            state.employee = employee;
        },

        SET_USER(state, user) {
            state.user = user;
            localStorage.setItem("cashWalletToken", JSON.stringify(user));
        },

        SET_LAST_ORDER(state, order) {
            state.lastOrder = order;
        },
    },

    actions: {
        setEmployee({ commit }, employee) {
            commit("SET_EMPLOYEE", employee);
        },

        doLogout() {
            localStorage.removeItem("cashWalletToken");
        },

        setUser({ commit }, user) {
            commit("SET_USER", user);
        },

        setLastOrder({ commit }, order) {
            commit("SET_LAST_ORDER", order);
        },

        clearLastOrder({ commit }) {
            commit("SET_LAST_ORDER", null);
        },

        getCreditLimit() {
            axios.get(`${API_URL}/employees/${this.employeeId}/limit_credit`);
        },

        getDayTotal() {
            const date = moment().format("YYYY-MM-DD");
            axios
                .get(
                    `${API_URL}/orders/employee-total/${this.employeeId}/${date}`
                )
                .then((res) => {
                    this.dayTotal = res.data.sum;
                });
        },
    },

    getters: {
        shopLimit(state) {
            if (state.user) {
                return parseFloat(state.user.day_limit);
            }
            return 0;
        },
    },
});
